import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const normalizeBaseUrl = (value) => {
  if (!value) return '';
  const trimmed = String(value).replace(/\/+$/, '');
  if (trimmed.endsWith('/api')) return trimmed.slice(0, -4);
  return trimmed;
};

const API = `${normalizeBaseUrl(process.env.REACT_APP_BACKEND_URL)}/api`;
const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('fyreserve_token');
    if (stored) {
      axios.get(`${API}/auth/check`, {
        headers: { Authorization: `Bearer ${stored}` }
      }).then(() => {
        setToken(stored);
      }).catch(() => {
        localStorage.removeItem('fyreserve_token');
      }).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = useCallback(async (password) => {
    const res = await axios.post(`${API}/auth/login`, { password });
    const t = res.data.token;
    localStorage.setItem('fyreserve_token', t);
    setToken(t);
    return t;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('fyreserve_token');
    setToken(null);
  }, []);

  const authAxios = useCallback(() => {
    return axios.create({
      baseURL: API,
      headers: { Authorization: `Bearer ${token}` }
    });
  }, [token]);

  return (
    <AuthContext.Provider value={{ token, loading, login, logout, authAxios }}>
      {children}
    </AuthContext.Provider>
  );
};
